import { gql } from "@apollo/client";

export const CREATE_EMAIL_LOG = gql`
  mutation CreateEmailLogMutation($input: CreateEmailLogInput!) {
    createEmailLog(input: $input) {
      ok
      error
      id
    }
  }
`;

export const UPDATE_EMAIL_LOG = gql`
  mutation UpdateEmailLogMutation($id: Int!, $input: UpdateEmailLogInput!) {
    updateEmailLog(id: $id, input: $input) {
      ok
      error
    }
  }
`;

export const REMOVE_EMAIL_LOG = gql`
  mutation RemoveEmailLogMutation($id: Int!) {
    removeEmailLog(id: $id) {
      ok
      error
    }
  }
`;

export const EMAIL_LOG = gql`
  query EmailLogQuery($id: Int!) {
    emailLog(id: $id) {
      ok
      error
      result {
        id
        recipient
        status
        sentAt
        messageId
      }
    }
  }
`;

export const EMAIL_LOGS = gql`
  query EmailLogsQuery($where: EmailLogsFiltersInput!) {
    emailLogs(where: $where) {
      ok
      error
      hasMore
      total
      results {
        id
        recipient
        status
        sentAt
      }
    }
  }
`;
